var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        { attrs: { justify: "end" } },
        [
          _c("v-col", [
            _c("h1", [_vm._v(_vm._s(_vm.$t("invoicing.purchasing.title")))])
          ]),
          _c(
            "v-col",
            { attrs: { cols: "auto" } },
            [
              _c(
                "v-btn",
                {
                  staticClass: "ma-2",
                  attrs: { color: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.navigate()
                    }
                  }
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("invoicing.transportEvents")) + " "
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      !_vm.byFilter ? _c("ReadyForPurchaseInvoicingTable") : _vm._e(),
      !_vm.byFilter ? _c("CreatedPurchaseInvoicesTable") : _vm._e(),
      _vm.byFilter ? _c("ReadyForPurchaseInvoicingByFilter") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }